import { APPLICATION_STATUS, type TApplicationStatusType } from '@fingerprinting/types'

import type { IClientBadgeProps } from '../../common/client-badge'

export function getChildren(status?: TApplicationStatusType | string): string {
  switch (status) {
    case APPLICATION_STATUS.PREPARING:
    case APPLICATION_STATUS.CREATED:
    case APPLICATION_STATUS.IN_PROGRESS:
      return 'Preparing'
    case APPLICATION_STATUS.APPROVED:
      return 'Approved'
    case APPLICATION_STATUS.VERIFYING:
      return 'Verifying'
    case APPLICATION_STATUS.COMPLETED:
    case APPLICATION_STATUS.SUBMITTED:
      return 'Completed'
    case APPLICATION_STATUS.APOSTILLE:
      return 'Apostille'
    case APPLICATION_STATUS.MAILING:
      return 'Mailing'
    default:
      return 'Unknown'
  }
}

export function getColor(status?: TApplicationStatusType | string): IClientBadgeProps['color'] {
  switch (status) {
    case APPLICATION_STATUS.PREPARING:
    case APPLICATION_STATUS.CREATED:
    case APPLICATION_STATUS.IN_PROGRESS:
      return 'info'
    case APPLICATION_STATUS.APPROVED:
      return 'success'
    case APPLICATION_STATUS.VERIFYING:
      return 'warning'
    case APPLICATION_STATUS.COMPLETED:
    case APPLICATION_STATUS.SUBMITTED:
      return 'success'
    case APPLICATION_STATUS.APOSTILLE:
      return 'submitted'
    case APPLICATION_STATUS.MAILING:
      return 'primary-500'
    default:
      return 'primary-500'
  }
}
